import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import notificationTranslations from "../languages/notification.json";
import systemNotificationsTranslations from "../languages/systemNotifications.json";
import {
  formatSystemNotificationTimestamp,
  localizeSystemNotification,
} from "../utils/systemNotificationText";
import "./notificationDetailsPopup.css";

export const NotificationDetailsPopup = ({
  open,
  notification,
  onClose,
  onMarkRead,
  onMarkUnread,
  onViewAll,
}) => {
  const { lang } = useContext(LanguageContext);
  const t =
    notificationTranslations[lang]?.notificationDetails ||
    notificationTranslations.en.notificationDetails;
  const systemNotificationsT =
    systemNotificationsTranslations[lang] || systemNotificationsTranslations.en;

  if (!open || !notification) return null;

  const localizedNotification = localizeSystemNotification(
    notification,
    systemNotificationsT
  );

  const title = localizedNotification?.title || t.titleFallback;
  const message = localizedNotification?.message || "";
  const status = String(notification?.status || "").toLowerCase();
  const type = notification?.type || "-";
  const createdAt =
    formatSystemNotificationTimestamp(notification?.created_at, lang) || "-";
  const deviceName = notification?.device?.name || notification?.device_name || "-";
  const did = notification?.device?.did || notification?.did || "-";
  const ownerName =
    notification?.device?.owner?.name ||
    notification?.device?.owner?.email ||
    notification?.owner_name ||
    "-";
  const subid = notification?.subid ?? notification?.device?.subid ?? "-";

  return (
    <div id="modal" className="notification-details-overlay" onClick={onClose}>
      <div
        id="popup"
        className="dashboard-modal notification-details-popup"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="dashboard-header">
          <div className="dashboard-header-icon notification-details-icon">
            <span>!</span>
          </div>
          <div className="dashboard-header-text">
            <h2>{title}</h2>
            <p>{createdAt}</p>
          </div>
        </div>

        <div className="modal-divider" />

        <div className="modal-content dashboard-content notification-details-body">
          <div className="notification-details-row">
            <span className="notification-details-label">{t.labels.message}</span>
            <div className="notification-details-message">{message || "-"}</div>
          </div>

          <div className="notification-details-grid">
            <div className="notification-details-row">
              <span className="notification-details-label">{t.labels.type}</span>
              <span className="notification-details-value">{type}</span>
            </div>
            <div className="notification-details-row">
              <span className="notification-details-label">{t.labels.status}</span>
              <span className={`notification-details-status ${status}`}>
                {status === "unread" ? t.statuses.unread : status === "read" ? t.statuses.read : "-"}
              </span>
            </div>
            <div className="notification-details-row">
              <span className="notification-details-label">{t.labels.device}</span>
              <span className="notification-details-value">{deviceName}</span>
            </div>
            <div className="notification-details-row">
              <span className="notification-details-label">{t.labels.did}</span>
              <span className="notification-details-value">{did}</span>
            </div>
            <div className="notification-details-row">
              <span className="notification-details-label">{t.labels.owner}</span>
              <span className="notification-details-value">{ownerName}</span>
            </div>
            <div className="notification-details-row">
              <span className="notification-details-label">{t.labels.subscriber}</span>
              <span className="notification-details-value">{subid}</span>
            </div>
          </div>
        </div>

        <div className="modal-footer dashboard-footer notification-details-footer">
          <button
            type="button"
            className="btn notification-details-btn notification-details-btn-close"
            onClick={onClose}
          >
            {t.actions.close}
          </button>

          <div className="notification-details-footer-actions">
            {status === "unread" && onMarkRead ? (
              <button
                type="button"
                className="btn btn-apply notification-details-btn notification-details-btn-action"
                onClick={onMarkRead}
              >
                {t.actions.markAsRead}
              </button>
            ) : null}
            {status === "read" && onMarkUnread ? (
              <button
                type="button"
                className="btn btn-apply notification-details-btn notification-details-btn-action"
                onClick={onMarkUnread}
              >
                {t.actions.markAsUnread}
              </button>
            ) : null}
            {onViewAll ? (
              <button
                type="button"
                className="btn btn-apply notification-details-btn notification-details-btn-viewall"
                onClick={onViewAll}
              >
                {t.actions.viewAll}
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationDetailsPopup;
